export default __webpack_public_path__ + "static/media/investmentImage.1ba1b020.png";